module.exports = __webpack_public_path__ + "img/index_tree_y2.e9e2eb0e.png";